// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3xDIy","rootCenter":"LoadMoreObserver_rootCenter__24fNk","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__27kqc"};